// Единый стиль input-полей в SPA: тёмный фон контрастнее карточки,
// тонкий violet-ring при focus вместо «жирной серой рамки» из дефолтного
// shadcn Input.
//
// Background = oklch(0.1) — заметно темнее `--background` (0.145) и
// `--card` (0.205). По запросу заказчика для dark-темы. На light-теме
// потом подберём отдельно через `light:` modifier.
const FOCUS = "focus-visible:ring-1 focus-visible:ring-violet-500/40 focus-visible:border-input";
const BG = "bg-[oklch(0.1_0_0)] dark:bg-[oklch(0.1_0_0)]";

export const EDITABLE_FIELD_CLASS = `${BG} ${FOCUS}`;
export const READONLY_FIELD_CLASS = `${BG} cursor-default text-muted-foreground focus-visible:ring-0 focus-visible:border-input`;
